export const impactAxisIcons: { [key: number]: string } = {
  1: "🎓",
  2: "🔬",
  3: "🤝",
  4: "🌎",
  5: "📊",
  6: "⚖️",
};
